import {
  type CardPartner,
  type CategoryGroupTranslationResponse,
  type CategoryTranslationResponse,
  type CountryGroupResponse,
  type CountryGroupTranslationResponse,
  type CreateCategoryGroup,
  type CreateCategoryWithRule,
  type PatchCategoryGroupTranslations,
  type PatchCategoryTranslation,
  type PatchCategoryTranslations,
  type PatchCountryGroupTranslation,
  type PatchCountryGroupTranslations,
  SpendControlApiFactory as SpendControlContractApiFactory,
  type UpdateCategory,
  type UpdateCategoryGroup,
  type UpdateCategoryRule,
} from '@mynt/backoffice-api-spec/spendcontrols'
import Axios from 'api/axios'
import { SpendControlApiFactory } from 'api/swagger/definitions/backoffice'
import config from 'config'

export type {
  CardPartner,
  CategoryGroupTranslationResponse,
  CategoryTranslationResponse,
  CountryGroupResponse,
  CountryGroupTranslationResponse,
  PatchCategoryGroupTranslations,
  PatchCategoryTranslation,
  PatchCategoryTranslations,
  PatchCountryGroupTranslation,
  PatchCountryGroupTranslations,
  UpdateCategoryRule,
}

const spendControlApi = SpendControlApiFactory(undefined, config.boBaseUrl, Axios)
const spendControlContractApi = SpendControlContractApiFactory(undefined, config.boBaseUrl, Axios)

export const getRule = (ruleId: string) => spendControlApi.getSpendControlRuleV1(ruleId).then(({ data }) => data)
export const getCategoryById = (categoryId: string) => spendControlApi.getSpendControlCategoryV1(categoryId).then(({ data }) => data)
export const createCategoryWithRule = (params: CreateCategoryWithRule) =>
  spendControlContractApi.createCategoryWithRule(params).then(({ data }) => data)
export const createCategoryGroup = (params: CreateCategoryGroup) =>
  spendControlContractApi.createCategoryGroup(params).then(({ data }) => data)
export const getSpendControlCategories = (cardPartner: CardPartner) =>
  spendControlContractApi.getSpendControlCategories(cardPartner).then(({ data }) => data)
export const updateCategoryGroup = (id: string, params: UpdateCategoryGroup) =>
  spendControlContractApi.updateCategoryGroup(id, params).then(({ data }) => data)
export const updateCategory = (id: string, params: UpdateCategory) =>
  spendControlContractApi.updateCategory(id, params).then(({ data }) => data)
export const updateCategoryTranslations = (categoryId: string, body: PatchCategoryTranslations) =>
  spendControlContractApi.patchCategoryTranslations(categoryId, body).then(({ data }) => data)
export const updateCategoryGroupTranslations = (categoryGroupId: string, body: PatchCategoryGroupTranslations) =>
  spendControlContractApi.patchCategoryGroupTranslations(categoryGroupId, body).then(({ data }) => data)
export const getCategoryTranslations = (categoryId: string): Promise<CategoryTranslationResponse[]> =>
  spendControlContractApi.getCategoryTranslations(categoryId).then(({ data }) => data.translations)
export const getCategoryGroupTranslations = (categoryGroupId: string): Promise<CategoryGroupTranslationResponse[]> =>
  spendControlContractApi.getCategoryGroupTranslations(categoryGroupId).then(({ data }) => data.translations)
export const getCountryGroups = (): Promise<CountryGroupResponse[]> =>
  spendControlContractApi.getCountryGroups().then(({ data }) => data.countryGroups)
export const getCountryGroupTranslations = (countryGroupId: string): Promise<CountryGroupTranslationResponse[]> =>
  spendControlContractApi.getCountryGroupTranslations(countryGroupId).then(({ data }) => data.translations)
export const updateCountryGroupTranslations = (countryGroupId: string, body: PatchCountryGroupTranslations) =>
  spendControlContractApi.patchCountryGroupTranslations(countryGroupId, body).then(({ data }) => data)
export const deleteCategoryGroup = async (id: string): Promise<void> => {
  await spendControlContractApi.deleteCategoryGroup(id)
}
export const updateCategoryRule = (id: string, body: UpdateCategoryRule) =>
  spendControlContractApi.updateRuleOnCategory(id, body).then(({ data }) => data)
